import { Component, Input, OnInit, OnChanges, SimpleChanges, OnDestroy } from '@angular/core';
import { Patient } from '../../../health/doctor/patient';
import { PatientService } from '../../../services/patient.service';
import { LoaderService } from '../../../services/loader.service';
import { GlobalErrorHandlerService } from '../../../services/global-error.service';
import { AppContextService } from '../../../services/app-context.service';

@Component({
  selector: 'app-enrolled-patient-profile',
  templateUrl: './enrolled-patient-profile.component.html',
  styleUrls: ['./enrolled-patient-profile.component.scss']
})
export class EnrolledPatientProfileComponent implements OnInit, OnChanges, OnDestroy {
  @Input() patient_id: any;
  public patient: any;

  constructor(public patientService: PatientService, public loaderService: LoaderService,
    public globalErrorHandlerService: GlobalErrorHandlerService,
    private appContextService: AppContextService) { }

  ngOnInit(): void {
    // Update context with tab info
    this.appContextService.updateTabContext('app-enrolled-patient-profile');

    // Update context with patient ID immediately if available
    if (this.patient_id) {
      const patientIdNum = parseInt(this.patient_id, 10);
      console.log('🎯 Initial patient context set:', patientIdNum);
      this.appContextService.updateEntityId('patient_id', patientIdNum);

      // Then load patient data
      this.loadPatient();
    }
  }

  ngOnChanges(changes: SimpleChanges): void {
    // Detect when patient_id input changes (when switching between patient tabs)
    if (changes['patient_id']) {
      const oldValue = changes['patient_id'].previousValue;
      const newValue = changes['patient_id'].currentValue;

      console.log('🔄 Patient ID change detected:', {
        old: oldValue,
        new: newValue,
        isFirstChange: changes['patient_id'].firstChange
      });

      if (this.patient_id) {
        const patientIdNum = parseInt(this.patient_id, 10);

        // ALWAYS update context with new patient ID, even on first change
        console.log('📝 Updating context with patient_id:', patientIdNum);
        this.appContextService.updateEntityId('patient_id', patientIdNum);

        // Load new patient data only if not first change
        if (!changes['patient_id'].firstChange) {
          console.log('🔄 Loading patient data for ID:', patientIdNum);
          this.loadPatient();
        }
      }
    }
  }

  ngOnDestroy(): void {
    // Clear patient_id from context when leaving this component
    console.log('EnrolledPatientProfile destroyed - clearing patient context');
    // Note: We don't clear here because the parent EnrolledPatientComponent manages the patient_id
  }

  private loadPatient(): void {
    // Update context with patient ID
    this.appContextService.updateEntityId('patient_id', parseInt(this.patient_id, 10));

    this.loaderService.show();
    this.patientService.getPatient(this.patient_id).then(resp => {
      this.patient = new Patient().load_from_json(resp);
      this.loaderService.hide();
    }).catch(resp => {
      this.loaderService.hide();
      this.globalErrorHandlerService.error = resp.error.error;
    });
  }

}
